import { useMutation } from 'react-query';
import { MutationConfig, queryClient } from 'src/lib/react-query';
import useNotification from 'src/store/Notifications/useNotification';
import { axiosDefaultApi } from 'src/lib/axios';


const editPendingStatus = ( {data, pendingStatusId} : {data: IPostEditPendingStatus | {}, pendingStatusId: number}): Promise<string> => {
  return axiosDefaultApi.put(`/api/PendingStatus/UpdatePendingStatus/${pendingStatusId}`, data);
};

type QueryFnType = typeof editPendingStatus;

type UseEditPendingStatusOptions = {
  data: IPostEditPendingStatus | {};
  pendingStatusId: number;
  config?: MutationConfig<QueryFnType>;
};

export const useEditPendingStatus = ({ config }: UseEditPendingStatusOptions) => { 
    const {addNotification, setIsNotificationVisible} = useNotification();
    return useMutation({
        onError: (error: any) => {
            addNotification(`Υπήρξε κάποιο πρόβλημα στην επεξεργασία της Κατηγορίας Εκκρεμότητας.`, 500);
            console.error('Couldnt edit PendingStatus', error);
            setIsNotificationVisible(true)
          },
          onSuccess: () => {
            queryClient.invalidateQueries(["getAllPendingStatus"])
            addNotification('Η Κατηγορία Εκκρεμότητας Ενημερώθηκε.', 200);
            setIsNotificationVisible(true)
          },
        ...config,
        mutationFn: editPendingStatus,
    })
}